// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"303":"5122cba0","940":"14ec7c5e"}[chunkId] + ".css";
};